import styled from 'styled-components';
import { Menu } from 'antd';

export const StyledMenu = styled(Menu)`
  &.ant-menu {
    background: #121212 !important; // Фоновый цвет меню
    color: #fff !important; // Цвет текста по умолчанию
  }

  .ant-menu-item {
    color: #fff !important; // Цвет текста элементов меню
    &:hover {
      background: #ff7300 !important; // Фоновый цвет элемента при наведении
      color: #fff; // Цвет текста элемента при наведении
    }
  }

  .ant-menu-item-selected {
    background: #ff7300 !important; // Фоновый цвет выбранного элемента
    color: #fff !important; // Цвет текста выбранного элемента
    font-weight: bold !important; // Применить жирный шрифт к выбранному элементу
  }

  &.ant-menu-submenu-title {
    color: #fff !important; // Цвет текста подменю
    &:hover {
      background: #ff7300 !important; // Фоновый цвет подменю при наведении
      color: #fff !important; // Цвет текста подменю при наведении
    }
  }
`;